import type {
  dealerFiltersResult,
  dealerSearchOutgoingInternalError
} from "@dealer-center/ddc-pages-account-search-interface";
import { isDealerSearchOutgoingInternalError } from "@dealer-center/ddc-pages-account-search-interface";
import { getSearchFilterUrlToUse } from "./helper";

export const getDealerSearchFilters = async () => {
  const url = getSearchFilterUrlToUse();

  const handleParsedJson = (
    newData?: dealerFiltersResult | dealerSearchOutgoingInternalError
  ) => {
    if (isDealerSearchOutgoingInternalError(newData)) {
      throw new Error(newData.message);
    }
    return newData;
  };
  const handleResponse = (response: Response) => {
    if (!response.ok) {
      throw new Error(response.statusText);
    } else {
      return response.json() as Promise<
        dealerFiltersResult | dealerSearchOutgoingInternalError
      >;
    }
  };

  const result = await fetch(url);
  const response = await handleResponse(result);
  return handleParsedJson(response);
};
